import React, { useState, useEffect } from "react";
import { Modal, Button, Nav, NavItem, NavLink } from 'react-bootstrap';
import { Checkbox, Input, Select, TextArea } from '../../../Layout/Forms/Form'
import { Link, useParams } from "react-router-dom";
import NightspotRequests from "../NightspotRequests";

const ModalExcelHeader = ({ show, handleModalhide, data }) => {

    let params = useParams();
    const [timmerAnimation, setTimmerAnimation] = useState(0)
    useEffect(() => {
        if (timmerAnimation >= 1) {
            const min = 300;
            const max = 2800;
            const number = Math.floor(Math.random() * (max - min + 1)) + min;
            const timerId = setTimeout(() => {
                setTimmerAnimation(prev => {
                    if (prev >= 100) {
                        return -1;
                    } else if (prev >= 1) {
                        return prev + 1;
                    }
                    return prev;
                });
            }, number);

            return () => clearTimeout(timerId);
        }else if(timmerAnimation == -1){
            handleModalhide(true);
        }
    }, [timmerAnimation]);

    const handlerImportContactos = async () => {
        setTimmerAnimation(1)
        let info = await NightspotRequests.importContactsFromFile(params, {filename: data.filename});
        if (info && info.status) {
            setTimmerAnimation(100)
        }
    }

    const modalHide = () => {
        if (timmerAnimation == 0) {
            handleModalhide(true)
        }
    }

    return (
        <>
            <Modal show={show} onHide={modalHide} dialogClassName="reset-width-modal modal-width-50">
                <Modal.Header>
                    <Modal.Title>Importação Excel</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {/* <div className="row">
                        <div className="col-12">
                            <table className="table table-dark">
                                <thead>
                                    <tr>
                                        <th scope="col">Coluna</th>
                                        <th scope="col">Campo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Nome</td>
                                        <td></td>
                                    </tr>
                                    
                                </tbody>
                            </table>
                        </div>
                    </div> */}
                    <div className="row mb-5">
                        <div className="col-12">
                            Estamos prontos para iniciar a importação do seu ficheiro.
                            Encontramos <span className="badge bg-primary">{data.rows}</span> contactos.
                        </div>
                    </div>
                    {timmerAnimation > 0 ?
                        <div className="row" >
                            <div className="col-12">
                                <div className="progress" role="progressbar" ariaLabel="Animated striped example" aria-valuenow={timmerAnimation} aria-valuemin="0" aria-valuemax="100">
                                    <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: `${timmerAnimation}%` }}>{timmerAnimation}%</div>
                                </div>
                                <div className="mt-3 text-center">Não feche a página até o processo estar concluido</div>
                            </div>
                        </div>
                        : null}
                </Modal.Body>
                {timmerAnimation > 0 ? null : (
                    <Modal.Footer>

                        <Button variant="secondary" onClick={handleModalhide}>
                            Fechar
                        </Button>
                        <Button variant="primary" onClick={handlerImportContactos}>
                            Iniciar importação dos contactos
                        </Button>

                    </Modal.Footer>
                )}
            </Modal>

        </>
    )
}


export default ModalExcelHeader